module.exports = __webpack_public_path__ + "assets/img/img251.8f964fa5.png";